// extracted by mini-css-extract-plugin
export default {"rankingsWrapper":"instructionsStyles_rankingsWrapper__2r75s","banner":"instructionsStyles_banner__Qes53","container":"instructionsStyles_container__w+BxJ"};